//import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { ReferToneRequest } from '../api/tune/refertone/refertonerequest';
import { ReferToneResponse, ReferToneResponseDtoImpl } from '../api/tune/refertone/refertoneresponse';
import { APIFeatures } from '../util/apifeatures';
//import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { StatusCodes } from '../util/statuscodes';
import { Strings } from '../../utils/resources/strings';

export class ReferToneAPIProcessorImpl extends SixdeeCRBTAPIProcessor<ReferToneRequest, ReferToneResponse>
{
     execute(request: ReferToneRequest): void 
    {
        super.execute(request);
    } 

    //   execute()
    //  {
    //      console.log("execute() in SecurityTokenAPIProcessorImpl"); 

    //      let referToneResponse = new ReferToneResponseDtoImpl(APIFeatures.REFER_TONE, "Refer Tone Success");
         
    //      this.getAPISuccess(referToneResponse);
    //     }


     onSuccess(responseMapper: ResponseMapper): void {
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new ReferToneResponseDtoImpl(APIFeatures.REFER_TONE, "Refer Tone Success");

                this.getAPISuccess(response);
            }
        }
        catch (e) {
            this.getAPIFailure(new ReferToneResponseDtoImpl(APIFeatures.REFER_TONE, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);
     
            this.getAPIFailure(new ReferToneResponseDtoImpl(APIFeatures.REFER_TONE, responseMapper.getStatusMsg()));
        
    } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/refertoneapiprocessor.tsx